import axios from "axios";


const instance = axios.create({
	baseURL: "",  // Django 后端地址
  withCredentials: false, // 如果不需要 cookie
});

instance.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);

export default instance;
